import React from 'react';
import { Spinner } from 'reactstrap';

const Loader = (props) => {
  let IS_VISIBLE = props.visible;
  return (
    <div>
      {IS_VISIBLE ? <div id="loader"><Spinner color="light" /></div> : null}
    </div>
  );
}

export default Loader;